// Opens a shared confirmation modal and injects target URL and message.
import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    static values = {
        url: String,
        message: String
    }

    open(event) {
        event.preventDefault()

        const modalEl = document.getElementById("confirmModal")
        const messageEl = modalEl.querySelector("#confirmMessage")
        const form = modalEl.querySelector("form")

        messageEl.textContent = this.messageValue
        form.action = this.urlValue

        new Modal(modalEl).show()
    }
}
